import { BrowserModule, Title } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule, isDevMode } from '@angular/core'
import { StoreDevtoolsModule } from '@ngrx/store-devtools'
import { Logger } from 'angular2-logger/core'
import { SimpleNotificationsModule } from 'angular2-notifications'
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { RouterModule } from '@angular/router'
import { RouterStateSerializer, StoreRouterConnectingModule } from '@ngrx/router-store'
import { async } from 'rxjs/scheduler/async'

import { JeanService } from './api/api/services/jean.service'
import { UserV2Service } from './api/identity/services/user-v2.service'
import { AppComponent } from './app.component'
import { ApiInterceptor } from './shared/http/api.interceptor'
import { metaReducers, reducers, effects } from './store'
import { appRoutes, CustomSerializer } from './app.routing'
import { environment } from '../environments/environment'
import { SharedModule } from './shared/shared.module'
import { AppHttpInterceptor } from './shared/http/http.interceptor'
import { NotFoundComponent } from './not-found.component'
import { OfflineDialogComponent } from './offline-dialog.component'

@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    OfflineDialogComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes, {onSameUrlNavigation: 'reload'}),
    SimpleNotificationsModule.forRoot(),
    SharedModule.forRoot(),
    /*
      @ngrx
     */
    StoreModule.forRoot(reducers, {metaReducers}),
    EffectsModule.forRoot(effects),
    StoreRouterConnectingModule,
    !environment.production ? StoreDevtoolsModule.instrument({maxAge: 300}) : [],
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true},
    {provide: RouterStateSerializer, useClass: CustomSerializer},
    {provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true},
    {provide: 'DEBOUNCE_TIME', useValue: environment.debounceTime},
    {provide: 'SCHEDULER', useValue: async},
    JeanService,
    UserV2Service,
    Title,
  ],
  entryComponents: [
    OfflineDialogComponent
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
  constructor(private logger: Logger) {
    this.logger.level = environment.logger.level
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts